<template>
	<div class="notice-view">
		<div class="title">{{ notice.title }}</div>
		<div class="sub-info">
			<template v-if="notice.school.district_division">
				<div class="school">
					{{ notice.school.district_division.l2_name }}&nbsp;{{ notice.school.district_division.l3_name }}&nbsp;{{
						notice.school.name
					}}&nbsp;{{ notice.class_grade.class_name }}
				</div>
			</template>

			<div class="date">{{ notice.updated_at | dateonly }}</div>
		</div>
		<div class="content" v-html="notice.content" />

		<!-- 图片 -->
		<template v-if="notice.images">
			<div class="image_wrapper" v-for="(item, idx) in notice.images" :key="idx">
				<img :src="item" />
			</div>
		</template>

		<!-- 表格-->
		<div class="tables-area">
			<template v-for="(tblData, idx1) in notice.tables">
				<el-table :data="tblData.rows" :key="idx1" border class="attachment-table">
					<el-table-column v-for="(name, idx2) in tblData.fields" :key="idx2" :label="name">
						<template v-slot:default="slot">{{ slot.row[idx2] }}</template>
					</el-table-column>
				</el-table>
			</template>
		</div>

		<!-- 文件 -->
		<div v-if="notice.files" class="file-area">
			<h4>附件下载</h4>
			<el-table :data="notice.files" :show-header="false">
				<el-table-column label="文件">
					<template v-slot:default="slot">
						<el-link icon="el-icon-download" :href="slot.row.url">{{ slot.row.name }}</el-link>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		notice: {}
	}
}
</script>

<style lang="scss">
.notice-view {
	padding: 30px 120px 30px 120px;

	.title {
		text-align: center;
		font-size: 24px;
		color: #303133;
	}

	.sub-info {
		font-size: 12px;
		color: #909399;
		height: 26px;
		border-bottom: 1px solid #ebeef5;

		.school {
			float: left;
		}

		.date {
			float: right;
		}
	}

	.content {
		margin: 20px;
		font-size: 16px;
	}

	.image_wrapper {
		text-align: center;
		margin-top: 20px;

		img {
			max-width: 90%;
		}
	}

	.tables-area .attachment-table {
		margin-top: 50px;
	}

	.file-area {
		margin-top: 50px;
	}
}
</style>
